import { IDuDieuKienHocTapXetTotNghiepUpdateLockedRequest } from "../../../model/request/xet-tot-nghiep/IDuDieuKienHocTapXetTotNghiepUpdateLockedRequest";
import { IMarkDuDieuKienHocTapXetTotNghiepViewModel } from "../../../model/response/xet-tot-nghiep/IMarkDuDieuKienHocTapXetTotNghiepViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDuDieuKienKetQuaHocTapXetTotNghiepActionsObj = {
    LOAD_BY_DOT_XET_START: 0,
    LOAD_BY_DOT_XET_SUCCESS: [] as IMarkDuDieuKienHocTapXetTotNghiepViewModel[],
    LOAD_BY_DOT_XET_ERROR: "",

    UPDATE_LOCK_STATUS_START: {} as IDuDieuKienHocTapXetTotNghiepUpdateLockedRequest,
    UPDATE_LOCK_STATUS_SUCCESS: undefined,
    UPDATE_LOCK_STATUS_ERROR: "",

    CHANGE_SELECTED_IDS: {} as number[],
}

export const eDuDieuKienKetQuaHocTapXetTotNghiepActionIds = generateActionTypeIds(eDuDieuKienKetQuaHocTapXetTotNghiepActionsObj, "DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP");
export type IDuDieuKienKetQuaHocTapXetTotNghiepActionTypes = IGenericActionType<typeof eDuDieuKienKetQuaHocTapXetTotNghiepActionsObj, "DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP">;